'use strict';

Vue.component('awe-facets-logic', {
  props: {
    wtbid: {type: String},
    country:{type: String},
    lang: {type: String, default: 'en'},
    cascading: {type: Boolean, default: false}, // Whether facets are linked or independant
    defaultEan: {type: String, default: ''},
    multiSelect: {type: Boolean, default: false}, // whether each facet can have multiple values.
    setDefaultFilters: {type: Boolean, default: false}, // whether to apply default filters on facet refresh
    ready: {type: Boolean, default: false},
  },
  data: function(){
    return {
      facets: [],
      eans: [],
      filters: [], // selected values
      i18n: this.$root.i18n,
      utils: this.$root.Utils,
      newDefaultEan: '',
      facetsAborter: null,
    }
  },
  watch:{
    wtbid: {
      // refreshes facets if wtbid changes
      handler: async function(value){
        if (!value)
          return

        this.init()
        console.debug('filters after wtbid update', this.filters)
      },
      immediate: true
    },
    // refreshes facets if defaultEan changes
    defaultEan: function(value){
        if (!value)
            return

        this.init()
    },
    country: function(){
      this.init()
    },
    ready: function(){
      this.init()
    },
  },
  methods:{

    init: async function(){
      // no request until widget is opened
      // + not if defaultEan is set from the default rean returned by previous request
      if (!this.ready || (this.defaultEan && this.defaultEan === this.newDefaultEan))
        return

      // always clear filters when opening the widget with a different ean by default
      await this.clearAllFilters();

      const filters = new Array(this.facets.length)

      for (let i = 0 ; i < this.facets.length; i++){
        // take selected values from API response.
        // if empty and option is set, set default filters with first value.
        let selectedValues = this.facets[i].values.filter(x => x.selected).map(x => x.value || x.key)
        if (selectedValues.length === 0 && this.setDefaultFilters){
          const first = this.facets[i].values?.[0]
          const fallback = first?.value || first?.key
          selectedValues = fallback ? [fallback] : []
        }

        filters[i] = [
          this.facets[i].key,
          selectedValues,
        ]
      }
      this.filters = filters
    },
    // Queries API for facets according to the current filters
    getFacets: async function(filters){
      const ean = this.defaultEan;
      try{
        if (this.facetsAborter) {
          this.facetsAborter.abort();
        }

        this.facetsAborter = new AbortController();

        let qs = `?wtbid=${this.wtbid}&country=${this.country}&lang=${this.lang}&cascading=${this.cascading}&auto=${this.cascading}`
        if (ean)
          qs += `&ean=${ean}`
        if (app.draft)
          qs += '&draft=1'
        
        const filterQuery = this.filters.filter(x => x[1].length)
                                    .map(x => `"${encodeURIComponent(x[0])}":[${x[1].map(x => '"'+encodeURIComponent(x.replace(/"/g, '\\"'))+'"').join(',')}]` )
                                    .join(',')
        const url = 'https://wtb-api-hub.swaven.com/wtb/v2/api/search/products/facet'
        const res = await fetch(url + qs + `&filters={${filterQuery}}`, {
          credentials: 'include',
          signal: this.facetsAborter.signal
        })

        if (res.status !== 200){
          throw new Error('Request error')
        }

        const data = await res.json()
        this.facets = data.facets.map(x => {
          x.withImg = x.values.some(v => !!(v.imgUrl || v.thumbImgUrl))
          return x
        })
        this.eans = data.eans
        this.newDefaultEan = data.defaultEan

        this.$emit('eans-update', {
          eans: this.eans,
          defaultEan: this.newDefaultEan
        })
      }
      catch(ex) {
        if (ex.name !== 'AbortError')
          console.error(ex)
      }
      finally {
        this.facetsAborter = null;
      }
    },

    // Updates according to user action
    updateFacets: async function(item, idx){
      this.multiSelect
        ? this.updateMultiSelect(item, idx)
        : this.updateSingleSelect(item, idx);

      if (this.cascading){
        for (let i = idx+1; i < this.filters.length; i++){
          this.filters[i][1] = []
        }
      }

      await this.getFacets();

      // for multi-select non-cascading filters, some values might be invalidated with lateset selection
      if (this.multiSelect && !this.cascading) this.rebuildFilters();
    },
    updateSingleSelect(item, idx) {
      this.filters[idx][1] = [item.value]
    },
    updateMultiSelect(item, idx) {
      const addItem = !!item.selected;

      if (addItem) {
        this.filters[idx][1] = [...this.filters[idx][1], item.value];
      } else {
        this.filters[idx][1] = this.filters[idx][1].filter(filter => filter !== item.value);
      }
    },
    rebuildFilters() {
      const filters = new Array(this.facets.length)

      for (let i = 0 ; i < this.facets.length; i++){
        let selectedValues = this.facets[i].values.filter(x => x.selected).map(x => x.value || x.key)

        filters[i] = [
          this.facets[i].key,
          selectedValues,
        ]
      }

      this.filters = filters;
    },
    clearAllFilters: function() {
      const clearedFilters = new Array(this.filters.length)

      for (let i = 0; i < this.filters.length; i++) {
        clearedFilters[i] = [this.filters[i][0], []]
      }
      this.filters = clearedFilters

      return this.getFacets()
    },

  },
  render(){
    // returns only a slot with all public properties and methods
    return this.$scopedSlots.default({
      facets: this.facets,
      defaultEan: this.newDefaultEan,
      eans: this.eans,
      updateFacets: this.updateFacets,
      filters: this.filters,
      clearAllFilters: this.clearAllFilters,
    })
  }
})
